import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class RequireElevatedJitaPrompt extends Component {
  getElevatedJitaLink() {
    return `${getFullUrl('tools', {
      domainOverride: 'hubteam'
    })}/login/jita?jitaType=ELEVATED&email=${encodeURIComponent(this.props.currentUserEmail)}&jitaDuration=60&loginPortalId=${encodeURIComponent(
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
    PortalIdParser.get())}&loginPortalName=${encodeURIComponent(this.props.portalDomain)}&loginRedirectUrl=${encodeURIComponent(window.location.href)}`;
  }
  render() {
    return /*#__PURE__*/_jsx(View, {
      paddingBlock: "800",
      as: "div",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "center",
        padding: "800",
        children: [/*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(Illustration, {
            name: "keys",
            height: 150,
            paddingInlineEnd: "1200"
          })
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("h5", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "svh-workspace-ui-lib.requireElevatedJita.title"
            })
          }), /*#__PURE__*/_jsx(Text, {
            display: "block",
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "svh-workspace-ui-lib.requireElevatedJita.paragraph"
            })
          }), /*#__PURE__*/_jsx(Button, {
            use: "tertiary-light",
            marginBlockStart: "400",
            href: this.getElevatedJitaLink(),
            size: "sm",
            role: "button",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "svh-workspace-ui-lib.requireElevatedJita.buttonText"
            })
          })]
        })]
      })
    });
  }
}
RequireElevatedJitaPrompt.displayName = 'RequireElevatedJitaPrompt';
export default RequireElevatedJitaPrompt;